<template>
  <div>
    <Pane>
      <template v-slot:extra>
        <Draft @select="onSelectDraft" />
      </template>
    </Pane>

    <a-modal :visible="draftVisible" title="保存草稿" @ok="saveDraft" @cancel="cancelDraft">
      <div style="padding: 8px 0">
        <a-input placeholder="请输入草稿标题" v-model="draftTitle" />
      </div>
    </a-modal>

    <div class="container">
      <Detail />

      <div class="center">
        <a-space>
          <a-button @click="addDraft" :disabled="okDisabled">存草稿</a-button>

          <a-button type="primary" :disabled="okDisabled" :loading="loading" @click="ok">发起审批</a-button>
          <a-button @click="$close($route.path)">关闭</a-button>
        </a-space>

        <CommentModal
          :visible="commentVisible"
          :title="commentTitle"
          @setVisible="setCommentVisible"
          @done="done"
        />
      </div>
    </div>
  </div>
</template>

<script>
import watermark from "@/mixins/watermark";
import draft from "@/mixins/draft";
import Detail from "./detail.vue";
import { fetchModelList, allocate, fetchDetail } from "@/api/project";
import { mapMutations, mapGetters, mapState } from "vuex";

import { check } from "./utils/tools";
import { division } from "./utils/validate";
import CommentModal from "@/components/comment-modal";
import moment from "moment";

const roleRatioList = [
  {
    value: "major_charger",
    ratio: 0.1
  },
  {
    value: "design",
    ratio: 0.6
  },
  {
    value: "recheck",
    ratio: 0.15
  },
  {
    value: "audit",
    ratio: 0.1
  },
  {
    value: "approval",
    ratio: 0.05
  }
];

export default {
  name: "progressAllocate",

  mixins: [watermark, draft],

  components: {
    Detail,
    CommentModal
  },

  data() {
    return {
      id: null, // 项目 id

      loading: false,

      commentVisible: false, // 审批意见弹窗
      commentTitle: "",
      storageValue: [] // 暂存准备提交的数据
    };
  },

  activated() {
    const { query } = this.$route;
    const { id } = query || {};

    if (id && this.id !== id) {
      this.id = id;
      const hide = this.$message.loading("加载中...", 0);
      fetchDetail({
        id: this.id
      })
        .then(res => {
          if (Array.isArray(res.subPackages)) {
            this.setProject(res);
            this.setSubPackages(res.subPackages);
            this.getList();
          }
        })
        .finally(() => {
          hide();
        });
    }
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    // 提示语列表
    messageList() {
      return this.findDataDict("message");
    },
    // 角色类型列表
    roleTypeList() {
      return this.findDataDict("prjAllocateRole");
    },
    // 用户角色
    ...mapGetters("auth", ["isContractAdmin"]),

    // 阶段列表、分包列表、是否从项目详情页面过来
    ...mapState("allocate", ["list", "subPackages", "project"]),

    // 确认按钮是否禁用
    okDisabled() {
      // 所有的阶段都是不可配置的，就禁用
      let count = 0;
      this.list.forEach(element => {
        if (!element.configurable) {
          count++;
        }
      });
      return this.list.length === count;
    }
  },

  methods: {
    ...mapMutations("allocate", ["setList", "setSubPackages", "setProject"]),

    // 查询项目的分配情况
    getList() {
      const hide = this.$message.loading("加载中...", 0);
      fetchModelList({ id: this.id })
        .then(res => {
          if (Array.isArray(res)) {
            const newList = res.map(item => {
              // 如果不是配过的，那肯定没有成本，需要自己构建
              const newCostList = this.subPackages
                .filter(item => item.type === "JS3")
                .map(element => ({
                  major: element.major, // 这项分包关联的专业
                  planAmount:
                    (element.actualAmount
                      ? element.actualAmount
                      : element.planAmount) * (item.score ? item.score : 1), // 这项分包的预计（如果有实收金额就用实收）金额 * 审批时打的分
                  quota: item.phasePercent, // 关联的专业在这个阶段下的比重
                  companyId: element.companyId,
                  companyName: element.companyName
                }));

              console.log("newCostList ", newCostList);

              // 项目服务
              let first = item.allocateList.find(
                element => element.type === "dept_service"
              );
              if (!first) {
                first = {
                  type: "dept_service",
                  allocateQuota: 4,
                  disabled: true,
                  collapsed: false,
                  staffList: [
                    {
                      allocateUnit: "%",
                      allocateRatio: 100
                    }
                  ]
                };
              } else {
                first = {
                  ...first,
                  disabled: true,
                  staffList: first.allocateStaffList.map(el => {
                    return {
                      ...el,
                      allocateRatio:
                        el.allocateUnit === "万" && el.allocateAmount
                          ? division(el.allocateAmount)
                          : el.allocateRatio,
                      allocateAmount: undefined
                    };
                  })
                };
              }

              // 设计负责人
              let second = item.allocateList.find(
                element => element.type === "dept_charger"
              );
              if (!second) {
                second = {
                  type: "dept_charger",
                  allocateQuota: 6,
                  disabled: true,
                  collapsed: false,
                  staffList: [
                    {
                      allocateUnit: "%",
                      allocateRatio: 100
                    }
                  ]
                };
              } else {
                second = {
                  ...second,
                  disabled: true,
                  // staffList: second.allocateStaffList,
                  staffList: second.allocateStaffList.map(el => {
                    return {
                      ...el,
                      allocateRatio:
                        el.allocateUnit === "万" && el.allocateAmount
                          ? division(el.allocateAmount)
                          : el.allocateRatio,
                      allocateAmount: undefined
                    };
                  })
                };
              }
              // 技术经济
              let tec = item.allocateList.find(
                element => element.type === "tech_dept"
              );

              if (!tec) {
                if (item.allocateList.length === 0) {
                  // 从来没配置过
                  tec = {
                    // 技术经济
                    type: "tech_dept",
                    allocateQuota: 5,
                    collapsed: false,
                    staffList: [
                      ...this.roleTypeList.map(type => ({
                        role: type.value,
                        roleRatio:
                          roleRatioList.find(item => item.value === type.value)
                            .ratio * 100,
                        allocateUnit: "%",
                        allocateRatio: 100
                      }))
                    ]
                  };
                }
              } else {
                tec = {
                  ...tec,
                  allocateAmount: tec.allocateAmount
                    ? division(tec.allocateAmount)
                    : undefined,
                  // staffList: tec.allocateStaffList,

                  staffList: tec.allocateStaffList.map(el => {
                    return {
                      ...el,
                      allocateRatio:
                        el.allocateUnit === "万" && el.allocateAmount
                          ? division(el.allocateAmount)
                          : el.allocateRatio,
                      allocateAmount: undefined
                    };
                  })
                };
              }

              let majorGroupList = [];
              item.allocateList
                .filter(element => element.majorGroup)
                .forEach(element => {
                  const index = majorGroupList.findIndex(
                    major => major.majorGroup === element.majorGroup
                  );

                  if (index > -1) {
                    majorGroupList[index].list.push({
                      ...element,

                      staffList: element.allocateStaffList.map(el => {
                        return {
                          ...el,
                          allocateRatio:
                            el.allocateUnit === "万" && el.allocateAmount
                              ? division(el.allocateAmount)
                              : el.allocateRatio,
                          allocateAmount: undefined
                        };
                      })
                    });
                  } else {
                    majorGroupList.push({
                      majorGroup: element.majorGroup,
                      majorGroupQuota: element.majorGroupQuota,
                      list: [
                        {
                          ...element,

                          staffList: element.allocateStaffList.map(el => {
                            return {
                              ...el,
                              allocateRatio:
                                el.allocateUnit === "万" && el.allocateAmount
                                  ? division(el.allocateAmount)
                                  : el.allocateRatio,
                              allocateAmount: undefined
                            };
                          })
                        }
                      ]
                    });
                  }
                });

              if (majorGroupList.length === 0) {
                // 如果技术3有同种类型的分包，把他们合并
                let arr = [];
                newCostList.forEach(cost => {
                  const index = arr.findIndex(i => i.major === cost.major);
                  if (index > -1) {
                    arr[index] = {
                      ...arr[index],
                      quota: cost.quota + arr[index].quota
                    };
                  } else {
                    arr.push({
                      ...cost
                    });
                  }
                });

                if (arr.length > 0) {
                  majorGroupList = [
                    {
                      majorGroup: "子项1",
                      majorGroupQuota: 100,
                      list: arr.map(element => {
                        return {
                          allocateQuota: parseInt(100 / arr.length),
                          type: element.major,
                          collapsed: false,
                          staffList: [
                            ...this.roleTypeList.map(type => ({
                              role: type.value,
                              roleRatio:
                                roleRatioList.find(
                                  item => item.value === type.value
                                ).ratio * 100,
                              allocateUnit: "%",
                              allocateRatio: 100
                            }))
                          ]
                        };
                      })
                    }
                  ];
                }
              }

              // 施工配合和其他
              let otherList = [];
              const other1 = item.allocateList.find(
                element => element.type === "sgph"
              );
              const other2 = item.allocateList.find(
                element => element.type === "sgphqt"
              );
              if (other1) {
                otherList.push({
                  ...other1,
                  // staffList: other1.allocateStaffList,

                  staffList: other1.allocateStaffList.map(el => {
                    return {
                      ...el,
                      allocateRatio:
                        el.allocateUnit === "万" && el.allocateAmount
                          ? division(el.allocateAmount)
                          : el.allocateRatio,
                      allocateAmount: undefined
                    };
                  })
                });
              }
              if (other2) {
                otherList.push({
                  ...other2,
                  // staffList: other2.allocateStaffList,

                  staffList: other2.allocateStaffList.map(el => {
                    return {
                      ...el,
                      allocateRatio:
                        el.allocateUnit === "万" && el.allocateAmount
                          ? division(el.allocateAmount)
                          : el.allocateRatio,
                      allocateAmount: undefined
                    };
                  })
                });
              }

              let configurable = false;
              let configMessage = "";

              console.log("contract", this.project.contract.configureStatus);
              console.log("phaseProgressStatus", item.phaseProgressStatus);
              console.log("staffConfigureStatus", item.staffConfigureStatus);

              // 合同审批状态为已通过，才可以配置
              if (this.project.contract.configureStatus === "approved") {
                // 这个阶段的进度审核通过后，并且分配审核不处于审核中，审核通过，就可以配置
                if (item.phaseProgressStatus === "approved") {
                  if (
                    "reviewing approved".indexOf(item.staffConfigureStatus) ===
                    -1
                  ) {
                    configurable = true;
                    configMessage = "";
                  } else {
                    configMessage = "产值分配审批尚未通过，";
                  }
                } else {
                  configMessage = "阶段进度审批尚未通过，";
                }
                // 或者当前登录用户是合同管理员，只要不在审核中，就可以改
                if (
                  this.isContractAdmin &&
                  "reviewing".indexOf(item.staffConfigureStatus) === -1
                ) {
                  configurable = true;
                  configMessage = "";
                }
              } else {
                configMessage = "合同审批尚未通过，";
              }

              // 如果是往年的项目，不可配置
              if (item.legacy === "1") {
                configurable = false;
                configMessage = "历史项目";
              }

              console.log("configurable", configurable, configMessage);
              return {
                ...item,

                configurable,
                configMessage,

                // 每个阶段下有数据就拆分成几个字段，没有就自己构建
                // 前两个
                twoList: [first, second],

                tec,

                // 所有的子项，包括里面的专业
                majorGroupList,
                // 其他类型
                otherList,

                // 文件
                attachments: Array.isArray(item.fileList) ? item.fileList : [],

                // 如果有技术3的分包
                subCostQuotaList: Array.isArray(item.subCostQuotaList)
                  ? item.subCostQuotaList
                  : newCostList
              };
            });

            // 设置全局状态
            this.setList(newList);
          }
        })
        .finally(() => {
          hide();
        });
    },

    ok() {
      const message = check(this.list);
      if (message) {
        this.$message.error(message);
        return;
      }

      const params = this.list.filter(item => item.configurable);
      if (params.length === 0) {
        this.$message.error("所有阶段暂时无法配置！");
        return;
      }

      this.commentVisible = true;
      this.commentTitle = this.messageList.find(
        item => item.value === "allocate"
      ).name;
      this.storageValue = params;
    },

    // 审批意见弹窗设置
    setCommentVisible(visible) {
      this.commentVisible = visible;
    },

    done(comment) {
      this.allocateRequest(this.storageValue, comment);
    },

    allocateRequest(params, comment) {
      let arr = [];
      params.forEach(item => {
        let attachments = item.attachments.map(item => item.id);
        let allocateList = [];
        let twoList = item.twoList.map(element => {
          return {
            ...element,
            allocateStaffList: element.staffList.map(staff => {
              return {
                ...staff,
                allocateRatio:
                  staff.allocateUnit === "万"
                    ? staff.allocateRatio * 10000
                    : staff.allocateRatio
              };
            })
          };
        });

        allocateList.push(...twoList);

        if (item.tec) {
          let tec = {
            ...item.tec,
            allocateAmount: item.tec.allocateAmount
              ? item.tec.allocateAmount * 10000
              : undefined,
            allocateStaffList: item.tec.staffList.map(staff => {
              return {
                ...staff,
                allocateRatio:
                  staff.allocateUnit === "万"
                    ? staff.allocateRatio * 10000
                    : staff.allocateRatio
              };
            })
          };
          allocateList.push(tec);
        }

        let majorList = [];
        item.majorGroupList.forEach(major => {
          major.list.forEach(el => {
            majorList.push({
              ...el,
              majorGroup: major.majorGroup,
              majorGroupQuota: major.majorGroupQuota,
              allocateStaffList: el.staffList.map(staff => {
                return {
                  ...staff,
                  allocateRatio:
                    staff.allocateUnit === "万"
                      ? staff.allocateRatio * 10000
                      : staff.allocateRatio
                };
              })
            });
          });
        });

        allocateList.push(...majorList);

        let otherList = item.otherList.map(other => {
          return {
            ...other,
            allocateStaffList: other.staffList.map(staff => {
              return {
                ...staff,
                allocateRatio:
                  staff.allocateUnit === "万"
                    ? staff.allocateRatio * 10000
                    : staff.allocateRatio
              };
            })
          };
        });
        allocateList.push(...otherList);

        arr.push({
          ...item,

          subCostQuotaList: Array.isArray(item.subCostQuotaList)
            ? item.subCostQuotaList.map(cost => ({
                ...cost,
                quota: cost.quota ? cost.quota : 0
              }))
            : undefined,

          fileIdList: attachments,
          allocateList,

          twoList: undefined, // 前两个
          tec: undefined, // 技术经济
          majorGroupList: undefined
        });
      });

      console.log("final data", arr);
      console.log("===============");

      this.loading = true;
      allocate({
        projectId: this.id,
        progressList: arr,
        comment
      })
        .then(() => {
          this.$close(this.$route.path);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    saveDraft() {
      this.updateDraft({
        id: this.draftId ? this.draftId : undefined,
        title: this.draftTitle + " " + moment().format("YYYY-MM-DD"),
        type: this.draftType,
        content: JSON.stringify({
          list: this.list
        })
      }).then(() => {
        this.draftVisible = false;
        this.draftTitle = "";
      });
    },

    onSelectDraft(draft) {
      if (draft.id && draft.content) {
        this.draftId = draft.id; // 暂存使用的草稿 id
        this.draftTitle =
          typeof draft.title === "string" ? draft.title.split(" ")[0] : "";

        const res = JSON.parse(draft.content);
        this.setList(res.list);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding: 12px 12px 12px 0;
  background-color: #fff;
}

.center {
  padding: 48px 0;
}
</style>